<template>
  <div>
    <p class="cm-mg-p-wzd">
      {{ $t('common_words.farm_info') }}
    </p>
    <hr />
    <br />
    <div class="row">
      <div class="col-sm-4 col-md-2">
        <fg-input
          type="text"
          :label="`${$t('common_words.code')}: *`"
          v-model="model.code"
          name="common_words.code"
          v-validate="modelValidations.code"
          :error="getError('common_words.code', true)"
          placeholder="001"
        ></fg-input>
      </div>
      <div class="col-sm-8 col-md-5 col-lg-6 col-xl-7">
        <fg-input
          type="text"
          :label="`${$t('common_words.name')}: *`"
          v-model="model.name"
          name="common_words.name"
          v-validate="modelValidations.name"
          :error="getError('common_words.name', true)"
          :placeholder="`${$t('common_words.farm_inpute_name')}...`"
        ></fg-input>
      </div>
      <div class="col-sm-12 col-md-5 col-lg-4 col-xl-3">
        <fg-input
          :precision="2"
          :step="0.01"
          type="number"
          :label="`${$t('common_words.farm_size_ha')}: `"
          v-model="model.area"
          name="tfinca"
          placeholder="4.3"
        ></fg-input>
      </div>
      <div class="col-12">
        <fg-input
          type="email"
          :label="$t('common_words.principal_email')"
          placeholder="xxxx@gmail.com"
          v-model="model.email_notification"
          name="common_words.principal_email"
          v-validate="'email'"
          :error="getError('common_words.principal_email', true)"
        ></fg-input>
      </div>
      <div class="col-12">
        <fg-input
          type="email"
          :label="$t('common_words.secondary_email')"
          placeholder="xxxx@gmail.com"
          v-model="model.email_notification_two"
          name="common_words.secondary_email"
          v-validate="'email'"
          :error="getError('common_words.secondary_email', true)"
        ></fg-input>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <select-businesses-component
          :showLoading="false"
          :requiered="true"
          @onChange="updateSelectedBusinesses"
          @showHideLoading="showHideLoading"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import MixinMasters from 'src/util/mixinMasters';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinPermissions from 'src/util/mixinPermissions';

export default {
  data() {
    return {
      model: {
        id: null,
        name: null,
        code: null,
        area: null,
        email_notification: null,
        email_notification_two: null,
        businesses_id: [],
      },
      modelValidations: {
        name: {
          required: true,
        },
        code: {
          required: true,
        },
      },
      businesses: null,
    };
  },
  mixins: [MixinMasters, MixinPermissions, MixinForm],
  methods: {
    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'businesses_id', bsSelected);
    },
    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          if (!res) return res;
          if (!isset(this.model.businesses_id)) {
            this.validationInputsRequired('bus-rels', false, true);
            return false;
          } else return res;
        })
        .then((resp) => {
          this.$emit('on-validated', resp, {
            ...this.model,
            names_business: this.businesses
              .filter((business) =>
                this.model.businesses_id.includes(business.id)
              )
              .map((business) => business.name),
          });

          return resp;
        });
    },
  },

  mounted() {
    this.showHideLoading(true);
    if (this.isCreate() || this.isUpdate()) {
      Axios.getMasters('businesses/only')
        .then((response) => {
          this.businesses = this.concatAll(response.data.data);
          if (sessionStorage.getItem('editForm')) {
            const {
              id,
              code,
              name,
              area,
              email_notification,
              email_notification_two,
              businesses,
            } = JSON.parse(sessionStorage.getItem('editForm'));

            this.model = {
              id,
              code,
              name,
              area,
              email_notification,
              email_notification_two,
              businesses_id: businesses.map((element) => element.id),
            };

            this.showHideLoading();
          }
        })
        .catch((error) => this.showMessageErrors(error));
    } else this.showHideLoading();
  },
};
</script>
<style></style>
